






import HacoCommon from "../HacoCommon";

export default class Login extends HacoCommon {
  // put something
}
